// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-container {
    position: fixed;
    /* position: relative; */
    /* z-index: -1; */
    top: 0;
    bottom:0;
    overflow-y:scroll;
    overflow-x:hidden;
    width: 100%;
    height: 100svh;
    background-color: #ffffff;  
    display: flex;
    flex-direction: column;
    /* background-color: aqua; */
}

.hero-body-container {
    width: 100%;
    padding: 5vw;
    z-index: 0;
}
@media (min-width: 640px) {
    .hero-body-container{
        padding: 3vw;
    }
}
@media (min-width: 1024px) {
    .hero-body-container{
        padding: 1.5vw;
    }
}

.bounce-container {
    position: sticky;
    width: 100%;
    height: 100dvh;
    top: 0;
    z-index: 50;
    pointer-events: none;
    background-color: transparent;
    overflow:hidden;
}

.hero-gallery {
    position: absolute;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    /* background-color: #fffef9; */
    /* transform-style:; */
    /* perspective: 2000px; */
}

.block {
    position: absolute;
}

/* .block-1 {
    left: 8%;
    width: 140px;
    height: 165px;
    background-color: blue;
    animation: float;
    animation-iteration-count: infinite;
    animation-duration: 15s;
    animation-play-state: running;
    animation-timing-function: linear;
    z-index: 3;
}

.block-2 {
    left: 1%;
    width: 120px;
    height: 160px;
    background-color: green;
    animation: float;
    animation-iteration-count: infinite;
    animation-duration: 13s;
    animation-play-state: running;
    animation-timing-function: linear;
    z-index: 0;
}

.block-3 {
    left: 5%;
    width: 120px;
    height: 140px;
    background-color: aqua;
    animation: float;
    animation-iteration-count: infinite;
    animation-duration: 8s;
    animation-play-state: running;
    animation-timing-function: linear;
    z-index: 5;
}

.block-4 {
    left: 40%;
    width: 139px;
    height: 96px;
    background-image: url('../../public/asset/images/hero-2/SW_GRAINSLY.jpg');
    background-repeat: none;
    background-size: contain;
    animation: float;
    animation-iteration-count: infinite;
    animation-duration: 11s;
    animation-play-state: running;
    animation-timing-function: linear;
    z-index: 3;
}

.block-5 {
    left: 30%;
    width: 100px;
    height: 124px;
    background-image: url('../../public/asset/images/hero-2/PROJECT1945_7.jpg');
    background-repeat: none;
    background-size: cover;
    animation: float;
    animation-iteration-count: infinite;
    animation-duration: 14s;
    animation-play-state: running;
    animation-timing-function: linear;
    z-index: 0;
}

.block-6 {
    left: 18%;
    width: 96px;
    height: 100px;
    background-image: url('../../public/asset/images/hero-2/AINTNOMF_4.jpg');
    background-repeat: none;
    background-size: contain;
    animation: float;
    animation-iteration-count: infinite;
    animation-duration: 17s;
    animation-play-state: running;
    animation-timing-function: linear;
}

.block-7 {
    left: 60%;
    width: 130px;
    height: 170px;
    background-color: aquamarine;
    animation: float;
    animation-iteration-count: infinite;
    animation-duration: 10s;
    animation-play-state: running;
    animation-timing-function: linear;
    z-index: 6;
}

.block-8 {
    left: 72%;
    width: 110px;
    height: 135px;
    background-color: red;
    animation: float;
    animation-iteration-count: infinite;
    animation-duration: 14s;
    animation-play-state: running;
    animation-timing-function: linear;
}

.block-9 {
    left: 66%;
    width: 110px;
    height: 165px;
    background-color: aqua;
    animation: float;
    animation-iteration-count: infinite;
    animation-duration: 6s;
    animation-play-state: running;
    animation-timing-function: linear;
}

.block-10 {
    left: 89%;
    width: 140px;
    height: 165px;
    background-color: red;
    animation: float;
    animation-iteration-count: infinite;
    animation-duration: 17s;
    animation-play-state: running;
    animation-timing-function: linear;
}

.block-11 {
    left: 88%;
    width: 110px;
    height: 130px;
    background-image: url('../../public/asset/images/hero-2/SW_DANIEL\\ SURYA.jpg');
    background-repeat: none;
    background-size: contain;
    animation: float;
    animation-iteration-count: infinite;
    animation-duration: 9s;
    animation-play-state: running;
    animation-timing-function: linear;
    z-index: 3;
} */

@keyframes float {
    0% {
        bottom: -20%;
    }
    100% {
        bottom: 100%;
    }
}

.logo-1 {
    z-index: 999;
    display: none;
}
@media (min-width: 640px) {
    .logo-1{
        height: 1.6vw;
        width: auto;
        display: block;
    }
}
@media (min-width: 1024px) {
    .logo-1{
        display: none;
    }
}

.logo-2 {
    z-index: 999;
    width: auto;
    height: 3.1vw;
    display: block;
}
@media (min-width: 640px) {
    .logo-2{
        display: none;
    }
}
@media (min-width: 1024px) {
    .logo-2{
        display: none;
    }
}

.nav-link-work {
    display: none;
    justify-self: end;
    /* background-color: red; */
}
@media (min-width: 640px) {
    .nav-link-work{
        display: flex;
        grid-column-start: 6;
        grid-column-end: 7;
    }
}
@media (min-width: 1024px) {
    .nav-link-work{
        grid-column-start: 7;
        grid-column-end: 9;
    }
}

.nav-link-studio {
    display: none;
    justify-self: end;
    /* background-color: red; */
}
@media (min-width: 640px) {
    .nav-link-studio{
        display: flex;
        grid-column-start: 7;
        grid-column-end: 8;
    }
}
@media (min-width: 1024px) {
    .nav-link-studio{
        grid-column-start: 9;
        grid-column-end: 11;
    }
}

.nav-link-contact {
    display: none;
    justify-self: end;
    /* background-color: red; */
}
@media (min-width: 640px) {
    .nav-link-contact{
        display: flex;
        grid-column-start: 8;
        grid-column-end: 9;
    }
}
@media (min-width: 1024px) {
    .nav-link-contact{
        grid-column-start: 11;
        grid-column-end: 13;
    }
}

.hero-logo-container {
    /* position: fixed; */
    /* top: 0; */
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    width: 100%;
    z-index: -1;
    padding: 5vw;
}
@media (min-width: 640px) {
    .hero-logo-container{
        padding: 3vw;
    }
}
@media (min-width: 1024px) {
    .hero-logo-container{
        padding: 1.5vw;
    }
}

.hero-logo {
    /* z-index: 2; */
    /* position: absolute; */
    /* bottom: 0; */
    /* left: 0; */
    /* bottom: 5vw; */
    /* left: 5vw; */
    /* width: 92.5vw; */
    width: 100%;
    height: auto;
    /* padding: inherit; */
    margin-top: auto;

    color: #000000;
}

/* @media (min-width: 640px) {
    .hero-logo {
        bottom: 1.5vw;
        left: 1.5vw;
        width: 97vw;
    }
}
@media (min-width: 1024px) {
    .hero-logo {
        bottom: 0.5vw;
        left: 1.5vw;
        width: 96vw;
    }
} */

.hero-text-container {
    background-color: transparent;
    width: 100%;
    height: 100vh;
}

.hero-text-main {
    font-family: 'NeueHaasGrotesk';
    font-weight: normal;
    font-style: normal;
    font-size: 3.6vw;
    line-height: 4.8vw;
    color: #000000;
}
@media (min-width: 640px) {
    .hero-text-main {
        font-size: 1.8vw;
        line-height: 2.4vw;
    }
}
@media (min-width: 1024px) {
    .hero-text-main {
        font-size: 1.1vw;
        line-height: 1.5vw;
    }
}

.hero-text-pp {
    width: 100%;
    position: absolute;
    left: 50%;
    top: 45%;
    transform: translate(-50%, -50%);
    font-family: 'NeueHaasGroteskLight';
    font-weight: light;
    font-style: normal;
    font-size: 6.2vw;
    line-height: 7vw;
    color: #000000;
    pointer-events: none;
    text-align: center;
    padding: 0 4vw 0 4vw;
    text-transform: uppercase;
}
@media (min-width: 640px) {
    .hero-text-pp {
        font-size: 4.6vw;
        line-height: 5.2vw;
        padding: 0 3vw 0 3vw;
    }
}
@media (min-width: 1024px) {
    .hero-text-pp {
        font-size: 3.6vw;
        line-height: 3.6vw;
        padding: 0 12vw;
    }
}


.sub-hero-container {
    width: 100%;
    /* height: 100vh; */
    /* background-color: #000000; */
    padding: 0 4vw 0 4vw;
}
@media (min-width: 640px) {
    .sub-hero-container {
        padding: 0 2vw 0 2vw;
    }
}
@media (min-width: 1024px) {
    .sub-hero-container {
        padding: 0 1.5vw 6vw 1.5vw;
    }
}

.sub-hero-text {
    padding-top: 116vw;
    grid-column-start: 1;
    grid-column-end: 5;
    /* background-color: red; */
}
@media (min-width: 640px) {
    .sub-hero-text {
        padding-top: 74vw;
        grid-column-start: 1;
        grid-column-end: 9;
    }
}
@media (min-width: 1024px) {
    .sub-hero-text {
        padding-top: 28vw;
        grid-column-start: 3;
        grid-column-end: 11;
    }
}

.hero-text-pp-s {
    font-family: 'PPEiko';
    font-weight: normal;
    font-style: normal;
    font-size: 3.8vw;
    line-height: 4.8vw;
    color: #ffffff;
    pointer-events: none;
    text-align: center;
    /* white-space: nowrap; */
}
@media (min-width: 640px) {
    .hero-text-pp-s {
        font-size: 2.8vw;
        line-height: 3vw;
    }
}
@media (min-width: 1024px) {
    .hero-text-pp-s {
        font-size: 1.4vw;
        line-height: 1.8vw;
    }
}

#label {
	position: absolute;
    /* left: calc(50vw - 90px);
    top: calc(50vh - 90px); */
	/* width: 180px;
	height: 180px; */
    width: 32vw;
    height: 32vw;
    z-index: 40;
    background-size: contain;
}
@media (min-width: 640px) {
    #label {
        /* left: calc(50vw - 110px); */
        /* top: calc(50vh - 110px); */
        /* width: 220px;
        height: 220px; */
        width: 20vw;
        height: 20vw;
    }
}
@media (min-width: 1024px) {
    #label {
        /* left: calc(50vw - 110px); */
        /* top: calc(50vh - 110px); */
        /* width: 220px;
        height: 220px; */
        width: 12vw;
        height: 12vw;
    }
}

.hero-slider-container {
    height: 100vh;
    overflow: hidden;
    display: flex;
    left: 0;
    /* background-color: red; */
}

.pin-wrap {
    height: 100vh;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    /* background-color: #ffffff; */
    padding: 3.6vw 1.5vw 3.6vw 0;
}

.img-x {
    min-width: 40vw;
    padding: 0 1.5vw 0 1.5vw;
}
`, "",{"version":3,"sources":["webpack://./src/components/Hero/hero.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,wBAAwB;IACxB,iBAAiB;IACjB,MAAM;IACN,QAAQ;IACR,iBAAiB;IACjB,iBAAiB;IACjB,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;AACd;AACA;IACI;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,cAAc;IACd,MAAM;IACN,WAAW;IACX,oBAAoB;IACpB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,+BAA+B;IAC/B,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GAiJG;;AAEH;IACI;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;AACA;IACI;QACI,aAAa;QACb,WAAW;QACX,cAAc;IAClB;AACJ;AACA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,aAAa;IACb,cAAc;AAClB;AACA;IACI;QACI,aAAa;IACjB;AACJ;AACA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,2BAA2B;AAC/B;AACA;IACI;QACI,aAAa;QACb,oBAAoB;QACpB,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,oBAAoB;QACpB,kBAAkB;IACtB;AACJ;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,2BAA2B;AAC/B;AACA;IACI;QACI,aAAa;QACb,oBAAoB;QACpB,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,oBAAoB;QACpB,mBAAmB;IACvB;AACJ;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,2BAA2B;AAC/B;AACA;IACI;QACI,aAAa;QACb,oBAAoB;QACpB,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,qBAAqB;QACrB,mBAAmB;IACvB;AACJ;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,WAAW;IACX,WAAW;IACX,YAAY;AAChB;AACA;IACI;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;IACf,aAAa;IACb,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,gBAAgB;;IAEhB,cAAc;AAClB;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;IACI,6BAA6B;IAC7B,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI;QACI,gBAAgB;QAChB,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,gBAAgB;QAChB,kBAAkB;IACtB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,mCAAmC;IACnC,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,oBAAoB;IACpB,yBAAyB;AAC7B;AACA;IACI;QACI,gBAAgB;QAChB,kBAAkB;QAClB,oBAAoB;IACxB;AACJ;AACA;IACI;QACI,gBAAgB;QAChB,kBAAkB;QAClB,eAAe;IACnB;AACJ;;;AAGA;IACI,WAAW;IACX,mBAAmB;IACnB,+BAA+B;IAC/B,oBAAoB;AACxB;AACA;IACI;QACI,oBAAoB;IACxB;AACJ;AACA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,2BAA2B;AAC/B;AACA;IACI;QACI,iBAAiB;QACjB,oBAAoB;QACpB,kBAAkB;IACtB;AACJ;AACA;IACI;QACI,iBAAiB;QACjB,oBAAoB;QACpB,mBAAmB;IACvB;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI;QACI,gBAAgB;QAChB,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,gBAAgB;QAChB,kBAAkB;IACtB;AACJ;;AAEA;CACC,kBAAkB;IACf;6BACyB;CAC5B;iBACgB;IACb,WAAW;IACX,YAAY;IACZ,WAAW;IACX,wBAAwB;AAC5B;AACA;IACI;QACI,8BAA8B;QAC9B,6BAA6B;QAC7B;wBACgB;QAChB,WAAW;QACX,YAAY;IAChB;AACJ;AACA;IACI;QACI,8BAA8B;QAC9B,6BAA6B;QAC7B;wBACgB;QAChB,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,OAAO;IACP,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,+BAA+B;IAC/B,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B","sourcesContent":[".hero-container {\n    position: fixed;\n    /* position: relative; */\n    /* z-index: -1; */\n    top: 0;\n    bottom:0;\n    overflow-y:scroll;\n    overflow-x:hidden;\n    width: 100%;\n    height: 100svh;\n    background-color: #ffffff;  \n    display: flex;\n    flex-direction: column;\n    /* background-color: aqua; */\n}\n\n.hero-body-container {\n    width: 100%;\n    padding: 5vw;\n    z-index: 0;\n}\n@media (min-width: 640px) {\n    .hero-body-container{\n        padding: 3vw;\n    }\n}\n@media (min-width: 1024px) {\n    .hero-body-container{\n        padding: 1.5vw;\n    }\n}\n\n.bounce-container {\n    position: sticky;\n    width: 100%;\n    height: 100dvh;\n    top: 0;\n    z-index: 50;\n    pointer-events: none;\n    background-color: transparent;\n    overflow:hidden;\n}\n\n.hero-gallery {\n    position: absolute;\n    width: 100%;\n    height: 100vh;\n    overflow: hidden;\n    /* background-color: #fffef9; */\n    /* transform-style:; */\n    /* perspective: 2000px; */\n}\n\n.block {\n    position: absolute;\n}\n\n/* .block-1 {\n    left: 8%;\n    width: 140px;\n    height: 165px;\n    background-color: blue;\n    animation: float;\n    animation-iteration-count: infinite;\n    animation-duration: 15s;\n    animation-play-state: running;\n    animation-timing-function: linear;\n    z-index: 3;\n}\n\n.block-2 {\n    left: 1%;\n    width: 120px;\n    height: 160px;\n    background-color: green;\n    animation: float;\n    animation-iteration-count: infinite;\n    animation-duration: 13s;\n    animation-play-state: running;\n    animation-timing-function: linear;\n    z-index: 0;\n}\n\n.block-3 {\n    left: 5%;\n    width: 120px;\n    height: 140px;\n    background-color: aqua;\n    animation: float;\n    animation-iteration-count: infinite;\n    animation-duration: 8s;\n    animation-play-state: running;\n    animation-timing-function: linear;\n    z-index: 5;\n}\n\n.block-4 {\n    left: 40%;\n    width: 139px;\n    height: 96px;\n    background-image: url('../../public/asset/images/hero-2/SW_GRAINSLY.jpg');\n    background-repeat: none;\n    background-size: contain;\n    animation: float;\n    animation-iteration-count: infinite;\n    animation-duration: 11s;\n    animation-play-state: running;\n    animation-timing-function: linear;\n    z-index: 3;\n}\n\n.block-5 {\n    left: 30%;\n    width: 100px;\n    height: 124px;\n    background-image: url('../../public/asset/images/hero-2/PROJECT1945_7.jpg');\n    background-repeat: none;\n    background-size: cover;\n    animation: float;\n    animation-iteration-count: infinite;\n    animation-duration: 14s;\n    animation-play-state: running;\n    animation-timing-function: linear;\n    z-index: 0;\n}\n\n.block-6 {\n    left: 18%;\n    width: 96px;\n    height: 100px;\n    background-image: url('../../public/asset/images/hero-2/AINTNOMF_4.jpg');\n    background-repeat: none;\n    background-size: contain;\n    animation: float;\n    animation-iteration-count: infinite;\n    animation-duration: 17s;\n    animation-play-state: running;\n    animation-timing-function: linear;\n}\n\n.block-7 {\n    left: 60%;\n    width: 130px;\n    height: 170px;\n    background-color: aquamarine;\n    animation: float;\n    animation-iteration-count: infinite;\n    animation-duration: 10s;\n    animation-play-state: running;\n    animation-timing-function: linear;\n    z-index: 6;\n}\n\n.block-8 {\n    left: 72%;\n    width: 110px;\n    height: 135px;\n    background-color: red;\n    animation: float;\n    animation-iteration-count: infinite;\n    animation-duration: 14s;\n    animation-play-state: running;\n    animation-timing-function: linear;\n}\n\n.block-9 {\n    left: 66%;\n    width: 110px;\n    height: 165px;\n    background-color: aqua;\n    animation: float;\n    animation-iteration-count: infinite;\n    animation-duration: 6s;\n    animation-play-state: running;\n    animation-timing-function: linear;\n}\n\n.block-10 {\n    left: 89%;\n    width: 140px;\n    height: 165px;\n    background-color: red;\n    animation: float;\n    animation-iteration-count: infinite;\n    animation-duration: 17s;\n    animation-play-state: running;\n    animation-timing-function: linear;\n}\n\n.block-11 {\n    left: 88%;\n    width: 110px;\n    height: 130px;\n    background-image: url('../../public/asset/images/hero-2/SW_DANIEL\\ SURYA.jpg');\n    background-repeat: none;\n    background-size: contain;\n    animation: float;\n    animation-iteration-count: infinite;\n    animation-duration: 9s;\n    animation-play-state: running;\n    animation-timing-function: linear;\n    z-index: 3;\n} */\n\n@keyframes float {\n    0% {\n        bottom: -20%;\n    }\n    100% {\n        bottom: 100%;\n    }\n}\n\n.logo-1 {\n    z-index: 999;\n    display: none;\n}\n@media (min-width: 640px) {\n    .logo-1{\n        height: 1.6vw;\n        width: auto;\n        display: block;\n    }\n}\n@media (min-width: 1024px) {\n    .logo-1{\n        display: none;\n    }\n}\n\n.logo-2 {\n    z-index: 999;\n    width: auto;\n    height: 3.1vw;\n    display: block;\n}\n@media (min-width: 640px) {\n    .logo-2{\n        display: none;\n    }\n}\n@media (min-width: 1024px) {\n    .logo-2{\n        display: none;\n    }\n}\n\n.nav-link-work {\n    display: none;\n    justify-self: end;\n    /* background-color: red; */\n}\n@media (min-width: 640px) {\n    .nav-link-work{\n        display: flex;\n        grid-column-start: 6;\n        grid-column-end: 7;\n    }\n}\n@media (min-width: 1024px) {\n    .nav-link-work{\n        grid-column-start: 7;\n        grid-column-end: 9;\n    }\n}\n\n.nav-link-studio {\n    display: none;\n    justify-self: end;\n    /* background-color: red; */\n}\n@media (min-width: 640px) {\n    .nav-link-studio{\n        display: flex;\n        grid-column-start: 7;\n        grid-column-end: 8;\n    }\n}\n@media (min-width: 1024px) {\n    .nav-link-studio{\n        grid-column-start: 9;\n        grid-column-end: 11;\n    }\n}\n\n.nav-link-contact {\n    display: none;\n    justify-self: end;\n    /* background-color: red; */\n}\n@media (min-width: 640px) {\n    .nav-link-contact{\n        display: flex;\n        grid-column-start: 8;\n        grid-column-end: 9;\n    }\n}\n@media (min-width: 1024px) {\n    .nav-link-contact{\n        grid-column-start: 11;\n        grid-column-end: 13;\n    }\n}\n\n.hero-logo-container {\n    /* position: fixed; */\n    /* top: 0; */\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    width: 100%;\n    z-index: -1;\n    padding: 5vw;\n}\n@media (min-width: 640px) {\n    .hero-logo-container{\n        padding: 3vw;\n    }\n}\n@media (min-width: 1024px) {\n    .hero-logo-container{\n        padding: 1.5vw;\n    }\n}\n\n.hero-logo {\n    /* z-index: 2; */\n    /* position: absolute; */\n    /* bottom: 0; */\n    /* left: 0; */\n    /* bottom: 5vw; */\n    /* left: 5vw; */\n    /* width: 92.5vw; */\n    width: 100%;\n    height: auto;\n    /* padding: inherit; */\n    margin-top: auto;\n\n    color: #000000;\n}\n\n/* @media (min-width: 640px) {\n    .hero-logo {\n        bottom: 1.5vw;\n        left: 1.5vw;\n        width: 97vw;\n    }\n}\n@media (min-width: 1024px) {\n    .hero-logo {\n        bottom: 0.5vw;\n        left: 1.5vw;\n        width: 96vw;\n    }\n} */\n\n.hero-text-container {\n    background-color: transparent;\n    width: 100%;\n    height: 100vh;\n}\n\n.hero-text-main {\n    font-family: 'NeueHaasGrotesk';\n    font-weight: normal;\n    font-style: normal;\n    font-size: 3.6vw;\n    line-height: 4.8vw;\n    color: #000000;\n}\n@media (min-width: 640px) {\n    .hero-text-main {\n        font-size: 1.8vw;\n        line-height: 2.4vw;\n    }\n}\n@media (min-width: 1024px) {\n    .hero-text-main {\n        font-size: 1.1vw;\n        line-height: 1.5vw;\n    }\n}\n\n.hero-text-pp {\n    width: 100%;\n    position: absolute;\n    left: 50%;\n    top: 45%;\n    transform: translate(-50%, -50%);\n    font-family: 'NeueHaasGroteskLight';\n    font-weight: light;\n    font-style: normal;\n    font-size: 6.2vw;\n    line-height: 7vw;\n    color: #000000;\n    pointer-events: none;\n    text-align: center;\n    padding: 0 4vw 0 4vw;\n    text-transform: uppercase;\n}\n@media (min-width: 640px) {\n    .hero-text-pp {\n        font-size: 4.6vw;\n        line-height: 5.2vw;\n        padding: 0 3vw 0 3vw;\n    }\n}\n@media (min-width: 1024px) {\n    .hero-text-pp {\n        font-size: 3.6vw;\n        line-height: 3.6vw;\n        padding: 0 12vw;\n    }\n}\n\n\n.sub-hero-container {\n    width: 100%;\n    /* height: 100vh; */\n    /* background-color: #000000; */\n    padding: 0 4vw 0 4vw;\n}\n@media (min-width: 640px) {\n    .sub-hero-container {\n        padding: 0 2vw 0 2vw;\n    }\n}\n@media (min-width: 1024px) {\n    .sub-hero-container {\n        padding: 0 1.5vw 6vw 1.5vw;\n    }\n}\n\n.sub-hero-text {\n    padding-top: 116vw;\n    grid-column-start: 1;\n    grid-column-end: 5;\n    /* background-color: red; */\n}\n@media (min-width: 640px) {\n    .sub-hero-text {\n        padding-top: 74vw;\n        grid-column-start: 1;\n        grid-column-end: 9;\n    }\n}\n@media (min-width: 1024px) {\n    .sub-hero-text {\n        padding-top: 28vw;\n        grid-column-start: 3;\n        grid-column-end: 11;\n    }\n}\n\n.hero-text-pp-s {\n    font-family: 'PPEiko';\n    font-weight: normal;\n    font-style: normal;\n    font-size: 3.8vw;\n    line-height: 4.8vw;\n    color: #ffffff;\n    pointer-events: none;\n    text-align: center;\n    /* white-space: nowrap; */\n}\n@media (min-width: 640px) {\n    .hero-text-pp-s {\n        font-size: 2.8vw;\n        line-height: 3vw;\n    }\n}\n@media (min-width: 1024px) {\n    .hero-text-pp-s {\n        font-size: 1.4vw;\n        line-height: 1.8vw;\n    }\n}\n\n#label {\n\tposition: absolute;\n    /* left: calc(50vw - 90px);\n    top: calc(50vh - 90px); */\n\t/* width: 180px;\n\theight: 180px; */\n    width: 32vw;\n    height: 32vw;\n    z-index: 40;\n    background-size: contain;\n}\n@media (min-width: 640px) {\n    #label {\n        /* left: calc(50vw - 110px); */\n        /* top: calc(50vh - 110px); */\n        /* width: 220px;\n        height: 220px; */\n        width: 20vw;\n        height: 20vw;\n    }\n}\n@media (min-width: 1024px) {\n    #label {\n        /* left: calc(50vw - 110px); */\n        /* top: calc(50vh - 110px); */\n        /* width: 220px;\n        height: 220px; */\n        width: 12vw;\n        height: 12vw;\n    }\n}\n\n.hero-slider-container {\n    height: 100vh;\n    overflow: hidden;\n    display: flex;\n    left: 0;\n    /* background-color: red; */\n}\n\n.pin-wrap {\n    height: 100vh;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    /* background-color: #ffffff; */\n    padding: 3.6vw 1.5vw 3.6vw 0;\n}\n\n.img-x {\n    min-width: 40vw;\n    padding: 0 1.5vw 0 1.5vw;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
